import { Component } from '@angular/core';
import { ProductMenuFooterComponent } from '../product-menu-footer.component';
import { VariantBadge } from '../../../../../../../../models/product/dto/variant-badge';
import { FilterUtils } from '../../../../../../../../utils/filter-utils';

@Component({
  selector: 'app-plantlife-one-column-footer',
  templateUrl: './plantlife-one-column-footer.component.html',
  styleUrls: ['./plantlife-one-column-footer.component.scss'],
  standalone: false
})
export class PlantlifeOneColumnFooterComponent extends ProductMenuFooterComponent {
  public removePLKeywordBadges = (badge: VariantBadge) => {
    return FilterUtils.keepPlantLifeTaggedBadges(badge) && FilterUtils.removeBadgesWith86Keyword(badge);
  };
}
